import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function SteglitzZehlendorf() {
  return (
    <LocationPageTemplate
      page={{
        location: "Steglitz-Zehlendorf",
        locationSlug: "steglitz-zehlendorf",
        keyword: "Haushaltsauflösung Steglitz-Zehlendorf",
        metaTitle:
          "Haushaltsauflösung Steglitz-Zehlendorf | Festpreis & Termin in 48h",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Steglitz-Zehlendorf. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Steglitz-Zehlendorf – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb24813c089a7b14ae.jpg",
        localIntro: (
          <>
            <p>
              Der Bezirk Steglitz-Zehlendorf im Südwesten Berlins ist bekannt
              für seine gehobenen Wohnlagen, alten Villenviertel in Dahlem oder
              Zehlendorf und städtischeren Strukturen in Steglitz. Bei
              Haushaltsauflösungen in diesem Bezirk geht es oft um große
              Wohnflächen, umfangreiches Inventar und nicht selten auch um
              wertvolle Nachlässe.
            </p>
            <p>
              Die Räumung von großen Einfamilienhäusern oder Villen erfordert
              eine strukturierte Vorgehensweise und absolute Diskretion. Oft
              müssen auch großzügige Kellerräume, Dachböden oder weitläufige
              Gärten mit entrümpelt werden.
            </p>
            <p>
              Unser Team bringt die nötige Erfahrung und das Feingefühl mit, um
              auch anspruchsvolle Auflösungen in Steglitz-Zehlendorf
              professionell, respektvoll und zügig durchzuführen.
            </p>
          </>
        ),
        trustText:
          "Ob eine große Villa in Dahlem oder eine Wohnung in Steglitz – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Sehr professionelle und diskrete Abwicklung der Hausauflösung in Zehlendorf. Wir waren rundum zufrieden.",
        challengesText: (
          <>
            <p>
              Bei der Räumung großer Immobilien in Zehlendorf oder Dahlem sorgen
              wir für ausreichend Transportkapazitäten, um die Arbeiten zügig
              abzuschließen. Die fachgerechte und diskrete Entsorgung großer
              Mengen an Hausrat ist dabei selbstverständlich.
            </p>
            <p>
              In den dichter bebauten Bereichen von Steglitz kümmern wir uns im
              Vorfeld um die Einrichtung von Halteverbotszonen, um einen
              reibungslosen Ablauf zu gewährleisten. Bei wertvollen Nachlässen
              bieten wir eine faire Wertanrechnung an, die die Kosten der
              Räumung deutlich senken kann.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Zuverlässig, schnell und ein sehr fairer Preis. Die Wohnung in Steglitz wurde komplett besenrein übergeben.",
            author: "Kunde aus Steglitz",
          },
          {
            text: "Die Räumung des Hauses inklusive Keller und Garage verlief absolut reibungslos.",
            author: "Kundin aus Lichterfelde",
          },
          {
            text: "Sehr respektvoller Umgang mit dem Nachlass. Die Wertanrechnung war transparent und fair.",
            author: "Familie aus Zehlendorf",
          },
        ],
        neighbors: [
          { name: "Charlottenburg", slug: "charlottenburg" },
          { name: "Neukölln", slug: "neukoelln" },
          { name: "Potsdam", slug: "potsdam" },
        ],
        faqs: [
          {
            q: "Bieten Sie eine Wertanrechnung für Antiquitäten an?",
            a: "Ja, wir erkennen Wertgegenstände und rechnen diese transparent gegen die Kosten der Entrümpelung an.",
          },
          {
            q: "Räumen Sie auch sehr große Häuser oder Villen?",
            a: "Selbstverständlich. Wir haben die Kapazitäten, um auch sehr umfangreiche Objekte zügig und diskret zu räumen.",
          },
          {
            q: "Was kostet eine Haushaltsauflösung in Steglitz-Zehlendorf?",
            a: "Die Kosten hängen vom Aufwand ab. Nach einer kostenlosen Besichtigung erhalten Sie von uns einen verbindlichen Festpreis.",
          },
          {
            q: "Beantragen Sie die Halteverbotszone selbst?",
            a: "Ja, wir kümmern uns um die komplette Abwicklung mit dem Bezirksamt und stellen die Schilder rechtzeitig auf.",
          },
        ],
      }}
    />
  );
}
